module.exports = __webpack_public_path__ + "static/media/foodie.6fa92318.jpg";